import { render, staticRenderFns } from "./btm.vue?vue&type=template&id=843fb3ee&scoped=true&"
import script from "./btm.vue?vue&type=script&lang=js&"
export * from "./btm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843fb3ee",
  null
  
)

export default component.exports